module.exports = __webpack_public_path__ + "img/icon-close.4fb7fed7.svg";